if (!customElements.get('bonst-hero')) {
  customElements.define(
    'bonst-hero',
    class BonstHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.bonst-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('.bonst-hero__dot'));
        this.pauseButton = this.querySelector('.bonst-hero__pause');
        this.index = 0;
        this.speed = parseInt(this.dataset.speed, 10) || 6000;
        this.style.setProperty('--bonst-hero-speed', `${this.speed}ms`);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1 && !reduceMotion;
        if (!this.autoplay) this.dataset.autoplay = 'false';

        this.dots.forEach((dot) =>
          dot.addEventListener('click', () => {
            this.goTo(parseInt(dot.dataset.index, 10));
            this.restart();
          })
        );
        if (this.pauseButton) this.pauseButton.addEventListener('click', () => this.togglePause());

        // pause while keyboard focus is inside, and when off-screen
        this.addEventListener('focusin', () => this.hold(true));
        this.addEventListener('focusout', () => this.hold(false));
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((e) => (e.isIntersecting ? this.restart() : this.stop()));
        });
        this.observer.observe(this);

        // swipe on touch
        let startX = null;
        this.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
        this.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) {
            this.goTo(this.index + (dx < 0 ? 1 : -1));
            this.restart();
          }
          startX = null;
        });

        // theme editor: jump to the selected slide
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) {
            this.stop();
            this.goTo(i);
          }
        });
      }

      disconnectedCallback() {
        this.stop();
        if (this.observer) this.observer.disconnect();
      }

      goTo(i) {
        const n = this.slides.length;
        this.index = (i + n) % n;
        this.slides.forEach((s, k) => {
          const active = k === this.index;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
          s.querySelectorAll('a, button').forEach((el) => (active ? el.removeAttribute('tabindex') : el.setAttribute('tabindex', '-1')));
          const video = s.querySelector('video');
          if (video) active ? video.play().catch(() => {}) : video.pause();
        });
        this.dots.forEach((d, k) => {
          d.classList.toggle('is-active', k === this.index);
          k === this.index ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current');
          // restart the CSS progress animation
          const bar = d.querySelector('.bonst-hero__dot-progress');
          if (bar) {
            bar.style.animation = 'none';
            void bar.offsetWidth;
            bar.style.animation = '';
          }
        });
      }

      start() {
        if (!this.autoplay || this.timer) return;
        this.timer = setInterval(() => this.goTo(this.index + 1), this.speed);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      hold(on) {
        this.classList.toggle('is-paused', on || this.paused);
        on ? this.stop() : this.restart();
      }

      restart() {
        this.stop();
        if (this.paused) return;
        this.goTo(this.index);
        this.start();
      }

      togglePause() {
        this.paused = !this.paused;
        this.classList.toggle('is-paused', this.paused);
        const b = this.pauseButton;
        b.setAttribute('aria-label', this.paused ? b.dataset.labelPlay : b.dataset.labelPause);
        this.paused ? this.stop() : this.start();
      }
    }
  );
}